import { render, staticRenderFns } from "./PurchaseInvoiceRows.vue?vue&type=template&id=054d4fc6"
import script from "./PurchaseInvoiceRows.vue?vue&type=script&lang=ts"
export * from "./PurchaseInvoiceRows.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseInvoiceRows.vue?vue&type=style&index=0&id=054d4fc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports